import React from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Link from 'components/_new/typography/Link/Link'
import Text from 'components/_new/typography/Text/Text'

import InviteForm from 'components/_new/InviteFriendBlock//InviteForm/InviteForm'
import ShareButton from 'components/_new/buttons/ShareButton/ShareButton'

import messages from '../messages'
import s from './Mobile.scss'


const shareButtons = [ 'facebook', 'link', 'sms', 'gmail' ]

const Mobile = ({ page, withLink }) => (
  <Box className={s.container} pt="36" pb="16" pl="16" pr="16">
    <Text
      message={messages.title}
      size="28-40"
      color="white"
      semibold
      html
    />
    <div className={s.buttonsContainer}>
      {
        shareButtons.map((type, index) => (
          <Box key={index} mt={Boolean(index) && '8'}>
            <ShareButton page={page} type={type} />
          </Box>
        ))
      }
      <Box mt="16">
        <InviteForm page={page} />
      </Box>
    </div>
    {
      withLink && (
        <Box pt="36" pb="24" alignCenter>
          <Link
            message={messages.linkTitle}
            to={links.invite}
            withUnderline={false}
            color="white"
            withArrow
            semibold
          />
        </Box>
      )
    }
  </Box>
)

Mobile.propTypes = {
  page: PropTypes.string.isRequired,
  withLink: PropTypes.bool,
}


export default Mobile
